import { getIconByKey } from '@1debit/icons';
import Link from 'components/shared/Link/Link';
import { ContentfulLink } from 'libs/contentful/types';
import { PropsWithChildrenAndClass } from 'types/sharedComponents';
import { cn } from 'utils/styles';

const ArrowRightIcon = getIconByKey('arrow_right');

interface BaseTeaserLinkItemProps extends PropsWithChildrenAndClass, Pick<ContentfulLink, 'url' | 'internalPage'> {}

const BaseTeaserLinkItem = ({ url, internalPage, children, className }: BaseTeaserLinkItemProps) => {
  return (
    <Link
      href={url}
      internalPage={internalPage}
      withCtaAnalytics
      className="group rounded-[8px] w-full h-full ml:max-h-55">
      <div className={cn('rounded-[8px] sm:max-w-[314px] h-full w-full flex flex-col', className)}>{children}</div>
    </Link>
  );
};

export const TeaserLinkContent = ({ className, children }: PropsWithChildrenAndClass) => {
  return (
    <div
      className={cn(
        'grid grid-cols-[1fr_min-content] justify-between items-center text-label-saans min-h-6 grow h-full font-sans w-full text-wrap',
        className,
      )}>
      <span className="text-wrap">{children}</span>
      <ArrowRightIcon className="group-hover:inline group-focus:inline size-(--ck-icon-size)" />
    </div>
  );
};

export default BaseTeaserLinkItem;
